import { render, staticRenderFns } from "./aigenerated.vue?vue&type=template&id=fe881e2e"
import script from "./aigenerated.vue?vue&type=script&lang=js"
export * from "./aigenerated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports